/**
 * i18n — o idioma do front sai da CIDADE ativa (cities.js → `lang`), não do
 * navegador: cada tela exibe UMA cidade, e a cidade é que define a língua da
 * comunicação com quem assiste. Padrão `pt`; a Mexican Town é `es`.
 *
 * A CHAVE é o próprio texto em PORTUGUÊS — o idioma base do projeto. Duas razões:
 * o código continua legível (`t('JOGADORES')` em vez de `t('hud.players')`), e o
 * que ainda não foi traduzido cai de volta no português em vez de sumir ou virar
 * uma chave crua na tela.
 *
 * FORA daqui, de propósito:
 *   • painel de Configurações (⚙) — ferramenta de OPERADOR, segue em PT-BR;
 *   • `label` dos lotes (cities.js) — metadado do protocolo que o parceiro lê
 *     pelo `/catalog`, documentado no guia de integração; traduzir mudaria dado
 *     de contrato. O LETREIRO 3D do prédio é traduzido; o metadado não;
 *   • texto que o parceiro manda (`say`/`announce`/`message`) — o idioma ali é
 *     escolha dele.
 */

import { ACTIVE_CITY } from './world/cities.js';

/** Idioma da cidade ativa ('pt' | 'es'). */
export const LANG = ACTIVE_CITY.lang || 'pt';

const ES = {
  /* --- HUD e telas --- */
  JOGADORES: 'JUGADORES',
  MISSÕES: 'MISIONES',
  '🏆 missões concluídas': '🏆 misiones completadas',
  'carregando a cidade…': 'cargando la ciudad…',
  Jogador: 'Jugador',
  'Minha visão': 'Mi vista',
  'MINHA VISÃO': 'MI VISTA',
  Você: 'Tú',
  'Procurando você na cidade…': 'Buscándote en la ciudad…',
  'entrando na cidade…': 'entrando en la ciudad…',
  Reconectando: 'Reconectando',
  'Reiniciando a cidade…': 'Reiniciando la ciudad…',

  /* --- letreiros 3D dos prédios (o metadado `label` continua em PT) --- */
  ESCOLA: 'ESCUELA',
  VIAGENS: 'VIAJES',
  LABORATÓRIO: 'LABORATORIO',
  ELETRÔNICOS: 'ELECTRÓNICOS',
  PIZZARIA: 'PIZZERÍA',
  FARMÁCIA: 'FARMACIA',
  // BOUTIQUE, BIBLIOTECA, COWORKING, HOTEL e SPA são iguais nos dois idiomas

  /* --- plaquinhas das vitrines da loja de eletrônicos --- */
  GAMES: 'JUEGOS',
  ÁUDIO: 'AUDIO',
  DRONE: 'DRON',
  ROBÔ: 'ROBOT',
  // TV, CELULAR, PC, FOTO, TABLET, WI-FI e SMART são iguais

  /* --- relógios de fuso da agência de viagens --- */
  RIO: 'RÍO',
  DUBAI: 'DUBÁI',
  TÓQUIO: 'TOKIO',
  // N.YORK e LONDRES são iguais

  /* --- vitrines do laboratório clínico (builder aposentado, mas registrado) --- */
  EXAMES: 'EXÁMENES',
  ANÁLISES: 'ANÁLISIS',

  /* --- concessionária: "automotriz" é como o ramo é chamado no México --- */
  'AUTOMÓVEIS': 'AUTOMOTRIZ',

  /* --- letreiros dos novos prédios financeiros (distrito 1 da Mexican Town) --- */
  'SEGURADORA': 'ASEGURADORA',
  'CASA DA MOEDA': 'CASA DE MONEDA',
  'OURO E PRATA': 'ORO Y PLATA'
  // BOLSA é igual nos dois idiomas (a Bolsa Mexicana de Valores)
};

const DICT = { es: ES };

/** Traduz para o idioma da cidade. Sem tradução cadastrada, devolve o original. */
export function t(pt) {
  const d = DICT[LANG];
  return (d && d[pt]) || pt;
}

/**
 * Traduz os textos ESTÁTICOS do HTML marcados com `data-i18n`: o conteúdo atual do
 * elemento (em português) é a chave. Assim o HTML continua legível e não existe uma
 * segunda lista de chaves para manter em sincronia.
 *
 * Com `data-i18n="attr:title"` traduz o atributo em vez do texto.
 */
export function applyI18n(root = document) {
  if (LANG === 'pt') return; // idioma base: nada a fazer
  for (const el of root.querySelectorAll('[data-i18n]')) {
    const spec = el.getAttribute('data-i18n');
    if (spec && spec.startsWith('attr:')) {
      const name = spec.slice(5);
      el.setAttribute(name, t(el.getAttribute(name)));
    } else {
      el.textContent = t(el.textContent.trim());
    }
  }
}
